export const CarUtil = {
  convertDepositRegistration(deposit_registration_id) {
    switch (deposit_registration_id) {
      case 1:
        return "มัดจำเล่ม";
      case 2:
        return "ไม่มัดจำ";
      default:
        return "-";
    }
  },
  convertLicenseIdToName(liciense_status_id) {
    switch (liciense_status_id) {
      case 0:
        return "--ไม่ระบุ--";
      case 1:
        return "มีเล่ม";
      case 2:
        return "ยังไม่ปิดบัญชี";
      case 3:
        return "รอเล่มปิดบัญชี";
      case 4:
        return "มีเล่มอยู่เต็นท์";
      case 5:
        return "ไม่มีเล่ม";
      default:
        return "-";
    }
  },
  convertDocStatusName(doc_status) {
    // COMMENT 'N = New (Add New DOC)\nA = Approve\nR = Reject',
    switch (doc_status) {
      case "N":
        return "เอกสารใหม่";
      case "A":
        return "อนุมัติ";
      case "R":
        return "ยกเลิก";
      default:
        return "";
    }
  },

  getPersonVatOptions() {
    return [
      { value: 0, label: "--บุคคล/vat--" },
      { value: 1, label: "บุคคล" },
      { value: 2, label: "vat" },
    ];
  },

  convertPersonVatIdToName(person_vat_id) {
    // console.log("person_vat_id=", person_vat_id);
    switch (person_vat_id) {
      case 0:
        return "--บุคคล/vat--";
      case 1:
        return "บุคคล";
      case 2:
        return "vat";
      default:
        return "-";
    }
  },

  getCarStructureOptionName(car_structure) {
    let car_structure_name = car_structure.car_structure_name;
    let car_structure_group = car_structure.car_structure_group;
    if (car_structure_group === null || car_structure_group === "") {
      return car_structure_name;
    }

    return car_structure_name + " - " + "(" + car_structure_group + ")";
  },
};
